import { useQuery } from '@tanstack/react-query'
import { getTaskAttachments } from 'services/demands/demandsServices'
import { errorMessage } from 'services/messager'

const useDemandAttachments = (id) => {
	const { data, isLoading, isError } = useQuery({
		queryKey: ['demand-attachments', id],
		queryFn: () => fetchDemandAttachments(id),
		enabled: !!id,
		staleTime: 1000 * 30,
		refetchOnWindowFocus: true,
		retry: false,
	})

	async function fetchDemandAttachments() {
		try {
			const data = await getTaskAttachments(id)

			return data.attachments
		} catch (error) {
			console.log(error)
			errorMessage({
				content: 'Erro ao obter anexos da demanda',
			})
		}
	}

	return { data, isLoading, isError }
}

export default useDemandAttachments
